// extracted by mini-css-extract-plugin
export default {"Checkbox":"Checkbox_Checkbox__xq9cJ","Input":"Checkbox_Input__oauwh","StyledCheckbox":"Checkbox_StyledCheckbox__vqMom"};